import { z } from 'zod';
export const hexColorSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Cor hexadecimal no formato #RRGGBB');
export const FONT_FAMILIES = ['inter', 'manrope', 'source_sans', 'lora'];
/** Branding público: o que o portal do paciente precisa para renderizar a marca. */
export const publicBrandingSchema = z.object({
    organizationSlug: z.string(),
    displayName: z.string(),
    logoUrl: z.url().nullable(),
    logoDarkUrl: z.url().nullable(),
    faviconUrl: z.url().nullable(),
    colors: z.object({
        primary: hexColorSchema,
        secondary: hexColorSchema.nullable(),
        accent: hexColorSchema.nullable(),
    }),
    fontFamily: z.enum(FONT_FAMILIES).nullable(),
    aiDisplayName: z.string(),
    poweredByVisible: z.boolean(),
    version: z.number().int(),
});
export const provisionOrganizationSchema = z.object({
    legalName: z.string().min(2).max(200),
    tradeName: z.string().min(2).max(120),
    cnpj: z.string().regex(/^\d{14}$/, 'CNPJ com 14 dígitos, sem pontuação'),
    slug: z.string().optional(),
    plan: z.string().default('pilot'),
});
/** Marca editável pela clínica (painel → Marca) e pelo console. O logo é enviado à parte. */
export const clinicBrandingSchema = z.object({
    displayName: z.string(),
    aiDisplayName: z.string(),
    colorPrimary: z.string(),
    colorAccent: z.string().nullable(),
    logoUrl: z.string().nullable(),
    version: z.number().int(),
});
/** Logo em base64 (PNG, JPEG ou WebP, até 512 KB depois de decodificado). */
export const uploadLogoSchema = z.object({ image: z.string().min(16).max(720_000) });
//# sourceMappingURL=tenancy.js.map